import { useLang } from '@/i18n/LanguageContext';

export default function Marquee() {
  const { t } = useLang();
  const items = t.marquee;
  return (
    <section aria-hidden="true" className="overflow-hidden border-y hairline py-10 md:py-14" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {items.map((w, i) => (
              <span key={i} className="flex items-center whitespace-nowrap">
                <span className={`font-display text-[11vw] md:text-[6.5vw] px-8 ${i % 2 ? 'text-stroke' : ''}`}>{w}</span>
                <span className="text-[var(--pz-green)] text-2xl md:text-4xl" aria-hidden="true">
                  /
                </span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
